import { AfterViewInit, Component, ViewChild, ElementRef, ChangeDetectorRef, Renderer2, OnDestroy, OnInit, HostListener } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { ToastService } from '../../../../core/services/toast.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatService } from '../../services/chat.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { OpenApiService, Message, SummaryResponse } from '../../../../core/services/open-api.service';
import { marked, Renderer } from 'marked';
import * as Prism from 'prismjs';
import { DiffService } from '../../services/diff.service';
import { isCodingAnswer } from '../../services/coding-answer.model';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-kotlin';
import 'prismjs/components/prism-go';
import 'prismjs/components/prism-c';
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-csharp';
import { AuthService } from '../../../../core/services/auth.service';
import { DeepgramService } from '../../services/deepgram.service';
import { HeaderComponent } from "../../../../shared/components/layout/header/header.component";
import { ActivatedRoute } from '@angular/router';
import { ChatStreamRelayWebSocketService } from '../../../../core/services/chat-stream-relay-websocket.service';
import { API_URL, MAIN_PROD_WEBSOCKET_URL, WEBSOCKET_URL } from '../../../../config';

@Component({
  selector: 'app-user-chat-winodow',
  templateUrl: './user-chat-winodow.component.html',
  styleUrl: './user-chat-winodow.component.scss',
  animations: [
    trigger('coachCueAnim', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.5) translateY(20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'scale(1) translateY(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'scale(0.8) translateY(-10px)' }))
      ])
    ])
  ]
})
export class UserChatWinodowComponent implements OnDestroy, OnInit, AfterViewInit {
              public autoScrollAnimating = false;
            showAutoScrollToast() {
              // Use your toast service or a simple alert for demonstration
              if (this.toastService && typeof this.toastService.show === 'function') {
                // this.toastService.show('Auto-scroll stopped: reached bottom.', 'info', 3000);
              } else {
                // Fallback: simple alert
                // alert('Auto-scroll stopped: reached bottom.');
              }
            }
          private userIdleTimeout: any = null;
          private autoScrollSpeedup = false;
        isAutoScrolling = false;
      autoScrollEnabled = false;
      autoScrollOptions = [5, 7.5, 10, 12.5, 15, 17.5, 20, 22.5, 25]; 

      onAutoScrollToggle() {
        // Optionally, start/stop auto-scroll interval here
        if (this.autoScrollEnabled) {
          this.startAutoScrollInterval();
        } else {
          if (this.autoScrollInterval) {
            clearInterval(this.autoScrollInterval);
            this.autoScrollInterval = null;
          }
        }
      }

      onAutoScrollIntervalChange() {
        if (this.autoScrollEnabled) {
          this.startAutoScrollInterval();
        }
      }
    autoScrollIntervalSeconds = 10;
    intervalDropdownOpen = false;

    toggleIntervalDropdown(event: MouseEvent) {
      event.stopPropagation();
      this.intervalDropdownOpen = !this.intervalDropdownOpen;
    }

    selectInterval(sec: number, event: MouseEvent) {
      event.stopPropagation();
      this.autoScrollIntervalSeconds = sec;
      this.intervalDropdownOpen = false;
      this.onAutoScrollIntervalChange();
    }
  isLinkExpired = false;

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  userInput = '';
  recognition: any;
  isMicOn = false;
  isLoadingMessages = true;
  templateId: string = '';
  @ViewChild('zoomContainer', { static: false })
  zoomContainer!: ElementRef;
  showZoomIndicator = false;
  zoomLevel = 1;
  isStreaming = false;
  isNearBottom: boolean = true;
  isUserScrolling = false;

  // Auto-scroll while streaming properties
  private streamingAutoScrollInterval: any = null;
  // how many pixels to move every interval
  private autoScrollStep = 200; // pixels per interval
  // how often to auto-scroll while streaming (user requested 10 seconds)
  private autoScrollIntervalMs = 15000; // every 10 seconds
  private _programmaticScroll = false; // used to ignore scroll events caused by code
  private animationFrameId: number | null = null; // Track animation frame for cancellation

  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  private conversationSubscription: Subscription;
  private botMessageIndex: number = -1;
  private formatCache = new Map<string, SafeHtml>();
  private streamEndTimer: any = null;
  // Track the last completed bot message for LCS diff comparison
  private lastBotMessageText: string = '';
  menuOpen = false;

  // Coach cue overlay
  activeCoachCue: { emoji: string; label: string; svgKey?: string } | null = null;
  activeCoachCueSvgHtml: SafeHtml | null = null;
  private coachCueTimeout: any = null;
  private coachCueWs: WebSocket | null = null;

  // Inline SVG markup for animated custom cues (img tags block SVG animations)
  private static readonly COACH_CUE_SVGS: Record<string, string> = {
    'stop-sign': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><polygon points="50,4 82,18 96,50 82,82 50,96 18,82 4,50 18,18" fill="#dc2626" stroke="#991b1b" stroke-width="3"/><polygon points="50,12 76,24 88,50 76,76 50,88 24,76 12,50 24,24" fill="none" stroke="#fff" stroke-width="2.5"/><text x="50" y="56" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="24" font-weight="900" fill="#fff" letter-spacing="2">STOP</text></svg>`,
    'nod-more': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><style>@keyframes nod{0%,100%{transform:rotate(0)}25%{transform:rotate(-12deg)}50%{transform:rotate(8deg)}75%{transform:rotate(-6deg)}}.head-group{animation:nod 1.2s ease-in-out infinite;transform-origin:50px 65px}</style><g class="head-group"><circle cx="50" cy="40" r="28" fill="#fbbf24" stroke="#f59e0b" stroke-width="2"/><circle cx="39" cy="35" r="3.5" fill="#1e293b"/><circle cx="61" cy="35" r="3.5" fill="#1e293b"/><path d="M37,48 Q50,58 63,48" fill="none" stroke="#1e293b" stroke-width="2.5" stroke-linecap="round"/><path d="M50,5 L42,15 48,15 48,22 52,22 52,15 58,15Z" fill="#22c55e" opacity=".85"/><path d="M50,78 L42,68 48,68 48,61 52,61 52,68 58,68Z" fill="#22c55e" opacity=".85"/></g><rect x="44" y="68" width="12" height="10" rx="3" fill="#fbbf24" stroke="#f59e0b" stroke-width="1.5"/><rect x="35" y="78" width="30" height="14" rx="5" fill="#6366f1"/></svg>`,
    'sit-up': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><style>@keyframes straighten{0%,15%{transform:rotate(15deg)}40%,100%{transform:rotate(0)}}.body-group{animation:straighten 2s ease-out infinite;transform-origin:50px 85px}</style><rect x="30" y="60" width="40" height="5" rx="2" fill="#78716c"/><rect x="62" y="35" width="5" height="30" rx="2" fill="#78716c"/><rect x="62" y="32" width="10" height="5" rx="2" fill="#78716c"/><line x1="32" y1="65" x2="28" y2="90" stroke="#78716c" stroke-width="3" stroke-linecap="round"/><line x1="68" y1="65" x2="72" y2="90" stroke="#78716c" stroke-width="3" stroke-linecap="round"/><g class="body-group"><rect x="42" y="38" width="14" height="24" rx="5" fill="#6366f1"/><circle cx="49" cy="26" r="12" fill="#fbbf24" stroke="#f59e0b" stroke-width="1.5"/><circle cx="45" cy="24" r="2" fill="#1e293b"/><circle cx="53" cy="24" r="2" fill="#1e293b"/><path d="M44,30 Q49,34 54,30" fill="none" stroke="#1e293b" stroke-width="1.5" stroke-linecap="round"/><line x1="42" y1="44" x2="32" y2="56" stroke="#6366f1" stroke-width="4" stroke-linecap="round"/><line x1="56" y1="44" x2="66" y2="56" stroke="#6366f1" stroke-width="4" stroke-linecap="round"/><line x1="46" y1="62" x2="38" y2="82" stroke="#4f46e5" stroke-width="4" stroke-linecap="round"/><line x1="52" y1="62" x2="60" y2="82" stroke="#4f46e5" stroke-width="4" stroke-linecap="round"/></g><circle cx="82" cy="18" r="12" fill="#22c55e"/><path d="M76,18 L80,22 89,13" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    'enthuse': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><style>@keyframes bounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}@keyframes starBurst{0%,100%{opacity:.3;transform:scale(.7)}50%{opacity:1;transform:scale(1.1)}}@keyframes waveLeft{0%,100%{transform:rotate(-20deg)}50%{transform:rotate(-60deg)}}@keyframes waveRight{0%,100%{transform:rotate(20deg)}50%{transform:rotate(60deg)}}.figure{animation:bounce .8s ease-in-out infinite}.star1{animation:starBurst 1s ease-in-out infinite}.star2{animation:starBurst 1s ease-in-out .3s infinite}.star3{animation:starBurst 1s ease-in-out .6s infinite}.star4{animation:starBurst 1s ease-in-out .15s infinite}.star5{animation:starBurst 1s ease-in-out .45s infinite}.arm-left{animation:waveLeft .6s ease-in-out infinite;transform-origin:42px 48px}.arm-right{animation:waveRight .6s ease-in-out infinite;transform-origin:58px 48px}</style><g class="figure"><circle cx="50" cy="30" r="14" fill="#fbbf24" stroke="#f59e0b" stroke-width="1.5"/><ellipse cx="50" cy="36" rx="6" ry="4" fill="#1e293b"/><circle cx="44" cy="28" r="2.5" fill="#1e293b"/><circle cx="56" cy="28" r="2.5" fill="#1e293b"/><line x1="41" y1="23" x2="47" y2="22" stroke="#1e293b" stroke-width="1.5" stroke-linecap="round"/><line x1="53" y1="22" x2="59" y2="23" stroke="#1e293b" stroke-width="1.5" stroke-linecap="round"/><rect x="43" y="44" width="14" height="22" rx="5" fill="#ef4444"/><g class="arm-left"><line x1="42" y1="48" x2="24" y2="32" stroke="#ef4444" stroke-width="4.5" stroke-linecap="round"/><circle cx="22" cy="30" r="4" fill="#fbbf24"/></g><g class="arm-right"><line x1="58" y1="48" x2="76" y2="32" stroke="#ef4444" stroke-width="4.5" stroke-linecap="round"/><circle cx="78" cy="30" r="4" fill="#fbbf24"/></g><line x1="47" y1="66" x2="40" y2="86" stroke="#4f46e5" stroke-width="4" stroke-linecap="round"/><line x1="53" y1="66" x2="60" y2="86" stroke="#4f46e5" stroke-width="4" stroke-linecap="round"/><ellipse cx="38" cy="88" rx="5" ry="3" fill="#1e293b"/><ellipse cx="62" cy="88" rx="5" ry="3" fill="#1e293b"/></g><polygon class="star1" points="15,15 17,20 22,20 18,24 19,29 15,26 11,29 12,24 8,20 13,20" fill="#fbbf24"/><polygon class="star2" points="85,12 87,17 92,17 88,21 89,26 85,23 81,26 82,21 78,17 83,17" fill="#fbbf24"/><polygon class="star3" points="12,55 14,59 18,59 15,62 16,66 12,64 8,66 9,62 6,59 10,59" fill="#f97316"/><polygon class="star4" points="88,50 90,54 94,54 91,57 92,61 88,59 84,61 85,57 82,54 86,54" fill="#f97316"/><polygon class="star5" points="50,4 52,8 56,8 53,11 54,15 50,13 46,15 47,11 44,8 48,8" fill="#fbbf24"/></svg>`
  };

  @ViewChild('menuDropdown') menuDropdown!: ElementRef;

  constructor(
    public chatService: ChatService,
    private openApiService: OpenApiService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private authService: AuthService,
    private deepgramService: DeepgramService,
    private route: ActivatedRoute,
    private chatStreamRelayWebSocketService: ChatStreamRelayWebSocketService,
    private toastService: ToastService,
    private diffService: DiffService
  ) {
    // this.authService.setIsLoggedIn(true); // Set the user as logged in
    this.conversationSubscription = this.chatService.currentConversation$.subscribe(() => {
      // Only add copy buttons when not streaming — during streaming the DOM is
      // continuously replaced by new innerHTML, which would destroy the buttons.
      if (!this.isStreaming) {
        setTimeout(() => this.addCopyButtonsToCodeBlocks(), 100);
      }
    });
  }

  get currentConversation$() {
    return this.chatService.currentConversation$;
  }

  private autoScrollInterval: any = null;
  private uiNearBottomThreshold = 150; // px: how far from bottom before arrow shows

  // Overlay mode: when loaded inside consultant overlay iframe with ?overlay=true
  isOverlayMode = false;


  ngOnInit(): void {
    // Detect overlay mode via query param
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('overlay') === 'true') {
        this.isOverlayMode = true;
        // Ensure body/html are transparent — use setProperty with 'important' flag
        // to beat stylesheet rules like `body { background-color: #303AAB !important; }`
        document.documentElement.style.setProperty('background', 'transparent', 'important');
        document.documentElement.style.setProperty('background-color', 'transparent', 'important');
        document.body.style.setProperty('background', 'transparent', 'important');
        document.body.style.setProperty('background-color', 'transparent', 'important');
        document.documentElement.classList.add('overlay-mode');
        document.body.classList.add('overlay-mode');
      }
    }

    // Get from route param first
    this.templateId = this.route.snapshot.paramMap.get('id') || '';
    console.log('Template ID from route:', this.templateId);

    // Override ONLY IF search param exists
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const queryTemplateId = urlParams.get('templateId');
      if (queryTemplateId) {
        this.templateId = queryTemplateId;
      }
    }

    console.log('Final Template ID:', this.templateId);
    let chatId = this.templateId;

    console.log('[UserChat] Connecting to relay WebSocket with chatId:', chatId);
    // this.chatService.selectConversation({
    //   id: '',
    //   title: '',
    //   messages: [],
    //   chatThreadId: ''
    // });
     if (this.templateId) {
 this.openApiService.getPromptById(this.templateId).subscribe({
        next: (prompt: any) => {
                  const now = Date.now();
        const promptTimestamp = Number(prompt.timestamp);
        const fourHoursMs = 4 * 60 * 60 * 1000;
        if (now - promptTimestamp > fourHoursMs) {
          this.isLoadingMessages = false;
          this.isLinkExpired = true;
          // Show expired link, do not set empty conversation
        } else {
          this.isLinkExpired = false;
          // Link is active, fetch chat history
          this.openApiService.getUserChatHistoryByPromptId(this.templateId).subscribe((history: any[]) => {
            if (history && history.length > 0) {
              this.isLoadingMessages = true;
              const reversedHistory = [...history].reverse();
              const messages = reversedHistory.flatMap(h => {
                const msgs: Message[] = [];
                if (h.answer) {
                  let botText = h.answer;
                  msgs.push({ text: botText, sender: 'bot', timestamp: new Date(h.timestamp) });
                }
                return msgs;
              });
              // Annotate consecutive bot messages with diff context so refresh shows red/green
              let prevBotText: string | undefined;
              for (const msg of messages) {
                if (msg.sender === 'bot') {
                  if (prevBotText && this.hasCodeBlock(prevBotText) && this.hasCodeBlock(msg.text)) {
                    msg.showDiff = true;
                    msg.previousText = prevBotText;
                  }
                  prevBotText = msg.text;
                }
              }
              const conversation = {
                id: reversedHistory[0].chatThreadId || this.templateId,
                title: reversedHistory[0].question?.substring(0, 25) + '...' || 'Chat',
                messages,
                chatThreadId: reversedHistory[0].chatThreadId || this.templateId
              };
              this.chatService.selectConversation(conversation);
              // Seed lastBotMessageText from most recent bot answer for diff on next message
              const lastBotMsg = [...messages].reverse().find(m => m.sender === 'bot');
              if (lastBotMsg?.text) {
                if (!isCodingAnswer(lastBotMsg.text)) this.lastBotMessageText = lastBotMsg.text;
              }
              // Scroll to bottom after loading messages
              setTimeout(() => {
                this.forceScrollToAbsoluteBottom();
              }, 300);
            } else {
              // No history, set empty conversation
              this.chatService.selectConversation({
                id: '',
                title: '',
                messages: [],
                chatThreadId: ''
              });
            }
            this.isLoadingMessages = false;
             });
          }
        },
        error: (err) => {
          this.isLoadingMessages = false;
          this.isLinkExpired = false;
          // Show toast for invalid/expired chat code (500 error)
          if (err && err.status === 500) {
            this.toastService.show('Invalid chat code. Please check your link or code', 'error', 4000);
          } else {
            this.toastService.show('An error occurred while loading the chat. Please try again.', 'error', 4000);
          }
          // Optionally, clear conversation
          this.chatService.selectConversation({
            id: '',
            title: '',
            messages: [],
            chatThreadId: ''
          });
        }
      });
    } else {
      // No templateId, set empty conversation
      this.chatService.selectConversation({
        id: '',
        title: '',
        messages: [],
        chatThreadId: ''
      });
    }

    let reconnectAttempts = 0;
    const maxReconnectAttempts = 10;
    const reconnect = () => {
      if (reconnectAttempts >= maxReconnectAttempts) {
        console.error('[UserChat] Max WebSocket reconnect attempts reached.');
        return;
      }
      reconnectAttempts++;
      setTimeout(() => {
        console.warn(`[UserChat] Relay WebSocket reconnect attempt ${reconnectAttempts}`);
        this.chatStreamRelayWebSocketService.connect(chatId, onChunk, onClose);
      }, Math.min(1000 * reconnectAttempts, 10000)); // Exponential backoff, max 10s
    };

    const onChunk = (chunk: string) => {
      // Explicit new-answer signal from chat-window (sent when interviewer starts a new stream)
      if (chunk === '__NEW_ANSWER__') {
        this.botMessageIndex = -1;
        return;
      }
      // A coding answer too large for the relay was saved first; fetch it from history.
      if (chunk === '__CODING_ANSWER_SAVED__') {
        this.reloadConversationFromHistory();
        return;
      }

      // mark streaming in progress
      this.isStreaming = true;

      // Reset idle timer — when no chunk arrives for 2s, streaming is considered done
      if (this.streamEndTimer) clearTimeout(this.streamEndTimer);
      this.streamEndTimer = setTimeout(() => {
        this.isStreaming = false;
        this.streamEndTimer = null;
        // Fix 2: Only update baseline when the finished message contains code.
        // Text-only answers (e.g. "time complexity is O(n)") must not overwrite
        // the last code baseline, so the next code question still diffs correctly.
        if (this.botMessageIndex >= 0) {
          this.currentConversation$.pipe(take(1)).subscribe(conv => {
            const finishedText = conv?.messages[this.botMessageIndex]?.text || '';
            if (this.hasCodeBlock(finishedText)) {
              this.lastBotMessageText = finishedText;
            }
          });
        }
        setTimeout(() => this.addCopyButtonsToCodeBlocks(), 100);
      }, 2000);

      this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
        if (currentConv) {
          // Safety net: detect a new answer even if __NEW_ANSWER__ signal was missed.
          // The chat-window sends the FULL accumulated text each time, so a legitimate
          // continuation always starts with the current text. If it doesn't AND the new
          // chunk is shorter, this is a brand-new answer — force a new message box.
          if (this.botMessageIndex >= 0) {
            const existingText = currentConv.messages[this.botMessageIndex]?.text || '';
            // A coding answer streams as a series of complete snapshots, so a coding snapshot always continues it.
            const codingContinuation = isCodingAnswer(existingText) && isCodingAnswer(chunk);
            if (existingText.length > 0 && !codingContinuation && !chunk.startsWith(existingText) && chunk.length < existingText.length) {
              this.botMessageIndex = -1;
            }
          }

          if (this.botMessageIndex === -1) {
            // Immediately set to -2 to prevent duplicate message creation from rapid chunks
            this.botMessageIndex = -2;
            
            // Stop auto-scroll when new answer arrives
            const wasAutoScrolling = this.autoScrollEnabled;
            if (this.autoScrollInterval) {
              clearInterval(this.autoScrollInterval);
              this.autoScrollInterval = null;
            }
            this.isAutoScrolling = false;
            this.autoScrollAnimating = false;
            
            // Attach diff context if previous bot message had code
            const hasPrevCode = this.hasCodeBlock(this.lastBotMessageText);
            const placeholderMsg: Message = {
              text: '',
              sender: 'bot',
              timestamp: new Date(),
              showDiff: hasPrevCode,
              previousText: hasPrevCode ? this.lastBotMessageText : undefined
            };
            this.chatService.addMessage(placeholderMsg);
            
            // Scroll to show 15% of previous answer with more bottom space
            setTimeout(() => {
              this.currentConversation$.pipe(take(1)).subscribe((updatedConv: any) => {
                this.botMessageIndex = updatedConv.messages.length - 1;
                // Set the first chunk for the new message
                this.chatService.updateBotMessage(this.botMessageIndex, chunk);
                this.cdr.detectChanges();
                
                // Position the new answer with proper spacing
                setTimeout(() => {
                  this.scrollToShowPreviousAndNewAnswer();
                  
                  // Restart auto-scroll after 2 seconds if it was enabled
                  if (wasAutoScrolling) {
                    setTimeout(() => {
                      this.autoScrollEnabled = true;
                      this.startAutoScrollInterval();
                    }, 2000);
                  }
                }, 100);
              });
            }, 0);
            return;
          }
          
          // If botMessageIndex is -2, we're still initializing, skip this chunk
          if (this.botMessageIndex === -2) {
            return;
          }

          // Deduplicate: Only append the new part of the chunk if it extends the current text
          const currentText = currentConv.messages[this.botMessageIndex]?.text || '';
          let updatedText = currentText;
          if (chunk && chunk !== currentText) {
            if (chunk.startsWith(currentText)) {
              // Only append the new part
              updatedText = chunk;
            } else if (!currentText || currentText.length === 0) {
              updatedText = chunk;
            } else {
              // If chunk is not a continuation, avoid appending to prevent overlap
              updatedText = chunk;
            }
            this.chatService.updateBotMessage(this.botMessageIndex, updatedText);
            this.cdr.detectChanges();
            // Don't auto-scroll during streaming - keep current position
          }
        }
      });
    };

    const onClose = () => {
      console.warn('[UserChat] Relay WebSocket closed, attempting to reconnect...');
      // mark streaming as ended
      this.isStreaming = false;
      // Add copy buttons now that streaming is complete and DOM is stable
      setTimeout(() => this.addCopyButtonsToCodeBlocks(), 150);
      reconnect();
    };

    // If India Production, always use main prod websocket URL for user-chat window
    const isIndiaProd = API_URL.toLowerCase().includes('chat-ind-prod');
    const wsUrl = isIndiaProd ? MAIN_PROD_WEBSOCKET_URL : undefined;
    this.chatStreamRelayWebSocketService.connect(chatId, onChunk, onClose, wsUrl);

    // Connect to screenshot-relay WebSocket for coach cue messages from admin
    this.connectCoachCueWebSocket(chatId);

    if (this.templateId) {
      this.openApiService.getPromptById(this.templateId).subscribe((prompt: any) => {
        const now = Date.now();
        const promptTimestamp = Number(prompt.timestamp);
        const fourHoursMs = 4 * 60 * 60 * 1000;
        if (now - promptTimestamp > fourHoursMs) {
          this.isLoadingMessages = false;
          this.isLinkExpired = true;  // Set the flag indicating the link is expired
        } else {
          this.isLinkExpired = false;  // Set the flag to false if the link is valid
          // Link is active, fetch chat history
          this.openApiService.getUserChatHistoryByPromptId(this.templateId).subscribe((history: any[]) => {
            if (history && history.length > 0) {
              this.isLoadingMessages = true;
              const reversedHistory = [...history].reverse();
              const messages = reversedHistory.flatMap(h => {
                const msgs: Message[] = [];
                if (h.answer) {
                  let botText = h.answer;
                  msgs.push({ text: botText, sender: 'bot', timestamp: new Date(h.timestamp) });
                }
                return msgs;
              });
              // Annotate consecutive bot messages with diff context so refresh shows red/green
              let prevBotText: string | undefined;
              for (const msg of messages) {
                if (msg.sender === 'bot') {
                  if (prevBotText && this.hasCodeBlock(prevBotText) && this.hasCodeBlock(msg.text)) {
                    msg.showDiff = true;
                    msg.previousText = prevBotText;
                  }
                  prevBotText = msg.text;
                }
              }
              const conversation = {
                id: reversedHistory[0].chatThreadId || this.templateId,
                title: reversedHistory[0].question?.substring(0, 25) + '...' || 'Chat',
                messages,
                chatThreadId: reversedHistory[0].chatThreadId || this.templateId
              };
              this.chatService.selectConversation(conversation);
              // Seed lastBotMessageText from most recent bot answer for diff on next message
              const lastBotMsg = [...messages].reverse().find(m => m.sender === 'bot');
              if (lastBotMsg?.text) {
                if (!isCodingAnswer(lastBotMsg.text)) this.lastBotMessageText = lastBotMsg.text;
              }
              // Scroll to bottom after loading messages
              setTimeout(() => {
                this.forceScrollToAbsoluteBottom();
              }, 300);
            }
            this.isLoadingMessages = false;
          });
        }
      });
    }

    // Don't auto-scroll on initial load - keep at top
    // this.scrollToBottom();
    this.addCopyButtonsToCodeBlocks();
    // this.scrollToBottomWithPadding(10)
    // this.startAutoScrollInterval();
  }

  ngAfterViewInit(): void {
    // this.startAutoScrollInterval();
    // console.log('[AutoScroll] 10s auto-scroll interval started in ngAfterViewInit');
    
    // Add event listeners to stop auto-scroll on user interaction
    if (this.scrollContainer?.nativeElement) {
      const el = this.scrollContainer.nativeElement;
      
      // Stop auto-scroll on mouse wheel - use capture phase to intercept before scroll
      el.addEventListener('wheel', () => this.stopAutoScrollOnUserAction(), { passive: false, capture: true });
      
      // Stop auto-scroll on touch move (mobile)
      el.addEventListener('touchstart', () => this.stopAutoScrollOnUserAction(), { passive: false, capture: true });
      el.addEventListener('touchmove', () => this.stopAutoScrollOnUserAction(), { passive: false, capture: true });
      
      // Also detect mousedown on scrollbar
      el.addEventListener('mousedown', () => this.stopAutoScrollOnUserAction(), { capture: true });
    }
  }

  onScroll(): void {
    // Ignore scroll events caused by our own programmatic scrolling
    if (this._programmaticScroll) {
      return;
    }
    const el = this.scrollContainer.nativeElement;
    // Stop auto-scroll immediately on user interaction
    this.stopAutoScrollImmediately();
    // still update near-bottom status for UI (with hysteresis)
    this.updateNearBottom(el);
    this.isUserScrolling = el.scrollTop + el.clientHeight < el.scrollHeight;
    // Restart auto-scroll after user is idle for 2 seconds
    if (this.userIdleTimeout) clearTimeout(this.userIdleTimeout);
    this.userIdleTimeout = setTimeout(() => {
      this.isUserScrolling = false;
      if (this.autoScrollEnabled) {
        this.startAutoScrollInterval();
      }
    }, 2000);
  }

  /**
   * Immediately stop auto-scroll animation and interval
   */
  private stopAutoScrollImmediately(): void {
    // Cancel any ongoing animation frame
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
    
    // Clear the interval
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
    
    // Reset all flags immediately
    this.isAutoScrolling = false;
    this.autoScrollAnimating = false;
    this._programmaticScroll = false;
    this.autoScrollSpeedup = true; // Next scroll will be faster
  }

  /**
   * Called when user initiates scroll action (wheel, touch)
   */
  private stopAutoScrollOnUserAction(): void {
    // Only stop if currently auto-scrolling or animating
    if (this.isAutoScrolling || this.autoScrollAnimating) {
      this.stopAutoScrollImmediately();
    }
  }

  /**
   * Hysteresis for isNearBottom: prevents flicker of the scroll-to-bottom arrow.
   * - Show arrow if > 260px from bottom
   * - Hide arrow if < 160px from bottom
   */
  private updateNearBottom(el: HTMLElement) {
    const distance = el.scrollHeight - el.scrollTop - el.clientHeight;
    if (distance < 160) {
      this.isNearBottom = true;
    } else if (distance > 260) {
      this.isNearBottom = false;
    }
  }

  ngOnDestroy() {
    // Stop all animations and intervals
    this.stopAutoScrollImmediately();
    if (this.userIdleTimeout) clearTimeout(this.userIdleTimeout);
    if (this.streamEndTimer) clearTimeout(this.streamEndTimer);
    if (this.coachCueTimeout) clearTimeout(this.coachCueTimeout);

    // Close coach cue WebSocket
    if (this.coachCueWs) {
      this.coachCueWs.close();
      this.coachCueWs = null;
    }

    // this.authService.setIsLoggedIn(false);
    this.conversationSubscription.unsubscribe();
    this.chatStreamRelayWebSocketService.close();
  }

  /** Connect to screenshot-relay WebSocket to receive coach cue messages from admin */
  private connectCoachCueWebSocket(chatId: string): void {
    if (!chatId) return;

    const screenshotRelayUrl = WEBSOCKET_URL.replace('chat-stream-relay', 'screenshot-relay');
    const wsUrl = `${screenshotRelayUrl}?chatId=${chatId}`;
    this.coachCueWs = new WebSocket(wsUrl);

    this.coachCueWs.onmessage = (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'coach-cue' && data.emoji && data.label) {
          this.showCoachCue(data.emoji, data.label, data.svgKey);
        }
      } catch {
        // Ignore non-JSON messages (ping/pong etc.)
      }
    };

    this.coachCueWs.onclose = () => {
      // Auto-reconnect after 3 seconds
      setTimeout(() => {
        if (this.coachCueWs) {
          this.connectCoachCueWebSocket(chatId);
        }
      }, 3000);
    };

    this.coachCueWs.onerror = () => {
      // Will trigger onclose which handles reconnect
    };
  }

  /** Display a coach cue emoji overlay for 3 seconds */
  private showCoachCue(emoji: string, label: string, svgKey?: string): void {
    // Clear any existing timeout
    if (this.coachCueTimeout) clearTimeout(this.coachCueTimeout);

    this.activeCoachCue = { emoji, label, svgKey };
    // Pre-sanitize SVG HTML for inline rendering (img tags block SVG animations)
    if (svgKey && UserChatWinodowComponent.COACH_CUE_SVGS[svgKey]) {
      this.activeCoachCueSvgHtml = this.sanitizer.bypassSecurityTrustHtml(
        UserChatWinodowComponent.COACH_CUE_SVGS[svgKey]
      );
    } else {
      this.activeCoachCueSvgHtml = null;
    }
    this.cdr.detectChanges();

    // Auto-dismiss after 3 seconds
    this.coachCueTimeout = setTimeout(() => {
      this.activeCoachCue = null;
      this.cdr.detectChanges();
    }, 3000);
  }


  async typeBotMessage(fullText: string, messageIndex: number) {
    const parts = fullText.split(/(```[\s\S]*?```)/);
    let currentText = '';

    for (const part of parts) {
      currentText += part;
      this.chatService.updateBotMessage(messageIndex, currentText);
      if (!part.startsWith('```')) {
        await new Promise(res => setTimeout(res, 20)); // Type regular text quickly
      } else {
        await new Promise(res => setTimeout(res, 50)); // Pause slightly for code blocks
      }
    }
    this.chatService.finalizeConversation();
    this.cdr.detectChanges();
    this.addCopyButtonsToCodeBlocks();
  }





  // ---------------------------------------------------------------------------
  // Coding mode: coding answers are tagged envelopes rendered by <app-coding-answer>.
  // ---------------------------------------------------------------------------

  isCodingAnswer(text: string): boolean {
    return isCodingAnswer(text);
  }

  /** The header shows "Coding mode" while the latest answer is a coding answer. */
  isCodingConversation(conv: { messages: Message[] } | null | undefined): boolean {
    const last = conv ? [...conv.messages].reverse().find(m => m.sender === 'bot') : undefined;
    return isCodingAnswer(last?.text);
  }

  /** Code-block detection for the legacy diff view; coding-mode envelopes are not ordinary code answers. */
  private hasCodeBlock(text: string | undefined): boolean {
    return !!text && text.includes('```') && !isCodingAnswer(text);
  }

  /** Re-reads the saved conversation (used when a coding answer was too large for the relay). */
  private reloadConversationFromHistory(): void {
    if (!this.templateId) return;
    this.openApiService.getUserChatHistoryByPromptId(this.templateId).subscribe({
      next: (history: any[]) => {
        const reversedHistory = [...(history || [])].reverse();
        const messages: Message[] = reversedHistory
          .filter(h => h.answer)
          .map(h => ({ text: h.answer, sender: 'bot' as const, timestamp: new Date(h.timestamp) }));
        this.currentConversation$.pipe(take(1)).subscribe(conv => {
          this.chatService.selectConversation({
            id: conv?.id || this.templateId,
            title: conv?.title || '',
            messages,
            chatThreadId: conv?.chatThreadId || this.templateId
          });
          this.botMessageIndex = -1;
          this.isStreaming = false;
          this.cdr.detectChanges();
          setTimeout(() => this.scrollToShowPreviousAndNewAnswer(), 100);
        });
      },
      error: (err: unknown) => console.error('[UserChat] Could not reload the coding answer', err)
    });
  }

  formatMessage(text: string, message?: Message): SafeHtml {
    // Include a slice of previousText so history messages with different baselines
    // but identical response text don't collide in the cache.
    const prevSlice = message?.previousText ? message.previousText.slice(0, 80) : '';
    const cacheKey = (message?.id ?? '') + '|' + text + '|' + (message?.showDiff ? '1' : '0') + '|' + prevSlice;
    if (this.formatCache.has(cacheKey)) {
      return this.formatCache.get(cacheKey)!;
    }

    let result: SafeHtml;

    // LCS-based diff: use previousText stored on the message when showDiff is set
    if (message?.showDiff && message?.previousText) {
      result = this.formatMessageWithDiff(message.previousText, text);
    } else {
      const renderer = new Renderer();
      renderer.code = ({ text: code, lang }: { text: string; lang?: string }) => {
        const language = lang && Prism.languages[lang] ? lang : 'plaintext';

        // Inline --/++ marker diff (bot explicitly annotated its response)
        if (this.messageHasCompleteCodeBlock(text) && this.codeBlockHasDiffMarkers(code)) {
          const groupedHtml = this.buildInlineDiffHtml(code, language);
          return `<pre class="language-${language} diff-view"><code class="language-${language}">${groupedHtml}</code></pre>`;
        }

        let highlighted = code;
        try {
          if (language !== 'plaintext' && Prism.languages[language]) {
            highlighted = Prism.highlight(code, Prism.languages[language], language);
          } else {
            highlighted = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          }
        } catch (e) {
          highlighted = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
        return `<pre class="language-${language}"><code class="language-${language}">${highlighted}</code></pre>`;
      };
      const preprocessed = this.wrapAsciiArt(text);
    const parsed = marked.parse(preprocessed, { renderer }) as string;
      result = this.sanitizer.bypassSecurityTrustHtml(parsed);
    }

    if (this.formatCache.size > 200) {
      const firstKey = this.formatCache.keys().next().value;
      if (firstKey !== undefined) this.formatCache.delete(firstKey);
    }
    this.formatCache.set(cacheKey, result);
    return result;
  }

  formatMessageWithDiff(oldText: string, newText: string): SafeHtml {
    // Fix 3: Don't diff while streaming — wait until new response has a complete code block.
    if (!this.messageHasCompleteCodeBlock(newText)) {
      const renderer = new Renderer();
      renderer.code = ({ text: code, lang }: { text: string; lang?: string }) => {
        const language = lang && Prism.languages[lang] ? lang : 'plaintext';
        let highlighted = code;
        try {
          if (language !== 'plaintext' && Prism.languages[language]) {
            highlighted = Prism.highlight(code, Prism.languages[language], language);
          } else {
            highlighted = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          }
        } catch (e) {
          highlighted = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
        return `<pre class="language-${language}"><code class="language-${language}">${highlighted}</code></pre>`;
      };
      const parsed = marked.parse(newText, { renderer }) as string;
      return this.sanitizer.bypassSecurityTrustHtml(parsed);
    }

    const renderer = new Renderer();
    const oldCodeMatch = oldText.match(/```[\w]*\n?([\s\S]*?)```/);
    const rawOldCode = oldCodeMatch ? oldCodeMatch[1].trim() : '';
    const oldCode = this.sanitizeCodeForDiff(rawOldCode);
    let codeBlockIndex = 0;

    renderer.code = ({ text: code, lang }: { text: string; lang?: string }) => {
      const language = lang && Prism.languages[lang] ? lang : 'plaintext';
      const currentIndex = codeBlockIndex++;

      if (currentIndex === 0 && oldCode) {
        // Strip commented-out code lines from new code before diffing.
        // The bot sometimes includes the old version commented out inside the new response,
        // which causes all those lines to appear as green "added" lines in the diff.
        const cleanedNewCode = this.sanitizeCodeForDiff(
          code.split('\n').filter(l => !/^\s*\/\//.test(l)).join('\n')
        );

        // Fix 1: Similarity gate — if old and new code share < 20% common lines,
        // they are completely unrelated. Also skip when oldCode is empty.
        const oldLines = oldCode.split('\n').filter(l => l.trim().length > 2);
        const newLines = cleanedNewCode.split('\n').filter(l => l.trim().length > 2);
        const skipDiff = oldLines.length === 0 || newLines.length === 0 ||
          (oldLines.filter(l => newLines.includes(l)).length / Math.max(oldLines.length, newLines.length)) < 0.2;

        if (skipDiff) {
          const safeCode = this.sanitizeCodeForDiff(code);
          let highlighted = safeCode;
          try {
            if (language !== 'plaintext' && Prism.languages[language]) {
              highlighted = Prism.highlight(safeCode, Prism.languages[language], language);
            } else {
              highlighted = safeCode.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            }
          } catch (e) {
            highlighted = safeCode.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          }
          return `<pre class="language-${language}"><code class="language-${language}">${highlighted}</code></pre>`;
        }

        const diffLines = this.diffService.generateDiff(oldCode, cleanedNewCode);
        const groupedHtml = this.buildGroupedDiffHtml(diffLines, language);
        return `<pre class="language-${language} diff-view"><code class="language-${language}">${groupedHtml}</code></pre>`;
      }

      const cleanCode = this.sanitizeCodeForDiff(code);
      let highlighted = cleanCode;
      try {
        if (language !== 'plaintext' && Prism.languages[language]) {
          highlighted = Prism.highlight(cleanCode, Prism.languages[language], language);
        } else {
          highlighted = cleanCode.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
      } catch (e) {
        highlighted = cleanCode.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }
      return `<pre class="language-${language}"><code class="language-${language}">${highlighted}</code></pre>`;
    };

    const parsed = marked.parse(newText, { renderer }) as string;
    return this.sanitizer.bypassSecurityTrustHtml(parsed);
  }

  private buildGroupedDiffHtml(diffLines: Array<{ type: 'add' | 'remove' | 'unchanged'; content: string }>, language: string): string {
    const htmlParts: string[] = [];
    let hunkRemoved: string[] = [];
    let hunkAdded: string[] = [];

    const flushHunk = () => {
      for (const line of hunkRemoved) htmlParts.push(`<div class="ln-del">${line}</div>`);
      for (const line of hunkAdded) htmlParts.push(`<div class="ln-add">${line}</div>`);
      hunkRemoved = [];
      hunkAdded = [];
    };

    for (const diffLine of diffLines) {
      const highlighted = this.highlightDiffLine(diffLine.content, language);
      if (diffLine.type === 'remove') {
        hunkRemoved.push(highlighted);
      } else if (diffLine.type === 'add') {
        hunkAdded.push(highlighted);
      } else {
        flushHunk();
        htmlParts.push(`<div class="ln-unchanged">${highlighted}</div>`);
      }
    }
    flushHunk();
    return htmlParts.join('');
  }

  private sanitizeCodeForDiff(code: string): string {
    const markerWords = /\b(add|added|remove|removed|delete|deleted|change|changed|modify|modified|insert|inserted|old|new|keep|replace|this line|new line|old line)\b/i;
    let cleaned = code
      .split('\n')
      .map(line => {
        line = line.replace(/^(\s*)(\+\+|--)\s?/, '$1');
        const commentIdx = this.findCommentStart(line);
        if (commentIdx !== -1) {
          const commentText = line.slice(commentIdx);
          if (markerWords.test(commentText)) {
            line = line.slice(0, commentIdx).trimEnd();
          }
        }
        return line;
      })
      .join('\n');
    return cleaned.replace(/\n{3,}/g, '\n\n').trim();
  }

  private findCommentStart(line: string): number {
    let inSingle = false;
    let inDouble = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      const prev = i > 0 ? line[i - 1] : '';
      if (ch === "'" && !inDouble && prev !== '\\') { inSingle = !inSingle; continue; }
      if (ch === '"' && !inSingle && prev !== '\\') { inDouble = !inDouble; continue; }
      if (inSingle || inDouble) continue;
      if (ch === '/' && line[i + 1] === '/') return i;
      if (ch === '#') return i;
    }
    return -1;
  }

  private codeBlockHasDiffMarkers(code: string): boolean {
    const lines = code.split('\n');
    const hasDel = lines.some(l => /^[ \t]*--(?!-)/.test(l));
    const hasAdd = lines.some(l => /^[ \t]*\+\+(?!\+)/.test(l));
    return hasDel && hasAdd;
  }

  private messageHasCompleteCodeBlock(text: string): boolean {
    const fenceRegex = /```[\s\S]*?```/;
    return fenceRegex.test(text);
  }

  /**
   * Detects ASCII art / diagrams outside of code fences and wraps them in
   * ``` fences so `marked` renders them as <pre> blocks instead of mangling
   * them into tables, lists, or paragraphs.
   *
   * Streaming-safe: if the text contains an unclosed code fence (still being
   * streamed), only the portion before that fence is processed.
   */
  private wrapAsciiArt(text: string): string {
    const fenceMarkers = text.match(/```/g);
    const hasUnclosedFence = fenceMarkers && fenceMarkers.length % 2 !== 0;

    let processable = text;
    let tail = '';
    if (hasUnclosedFence) {
      const lastFenceIdx = text.lastIndexOf('```');
      processable = text.substring(0, lastFenceIdx);
      tail = text.substring(lastFenceIdx);
    }

    const processed = this.wrapAsciiArtInText(processable);
    return processed + tail;
  }

  private wrapAsciiArtInText(text: string): string {
    const boxDrawing = /[┌┐└┘├┤┬┴┼─│═║╔╗╚╝╠╣╦╩╬╟╢╤╧╪┃┄┅┆┇┈┉┊┋╭╮╯╰]/;
    const asciiBoxLine = /^[ \t]*[+|][-=+]{2,}/;
    const multiPipe = (line: string) => (line.match(/\|/g) || []).length >= 2;
    const structuralLine = /^[ \t]*[+\-|=\/\\]+[ \t]*$/;
    const arrowPattern = /[-=]{2,}>|<[-=]{2,}|──>|<──|═══|╌╌>|→|←|↑|↓|↗|↘|↙|↖/;
    const box3dLine = /[\/\\].*\||\|.*[\/\\]/;

    const isAsciiArtLine = (line: string): boolean => {
      const trimmed = line.trim();
      if (trimmed.length < 2) return false;
      if (boxDrawing.test(line)) return true;
      if (asciiBoxLine.test(line)) return true;
      if (structuralLine.test(line) && trimmed.length >= 3) return true;
      if (multiPipe(line) && (/[+]/.test(line) || box3dLine.test(line) || /[-=]{2,}/.test(line))) return true;
      if (arrowPattern.test(line) && (line.includes('|') || /[+]/.test(line) || boxDrawing.test(line))) return true;
      if (box3dLine.test(line) && /[-=+]/.test(line)) return true;
      return false;
    };

    const parts = text.split(/(```[\s\S]*?```)/g);
    const result: string[] = [];

    for (const part of parts) {
      if (part.startsWith('```')) {
        result.push(part);
        continue;
      }

      const lines = part.split('\n');
      let i = 0;
      const output: string[] = [];

      while (i < lines.length) {
        if (isAsciiArtLine(lines[i])) {
          const blockStart = i;
          i++;
          while (i < lines.length) {
            if (isAsciiArtLine(lines[i])) {
              i++;
            } else if (i + 1 < lines.length && isAsciiArtLine(lines[i + 1])) {
              i++;
            } else if (i + 2 < lines.length && isAsciiArtLine(lines[i + 2])) {
              i++;
            } else {
              break;
            }
          }
          const blockLines = lines.slice(blockStart, i);
          if (blockLines.filter(l => isAsciiArtLine(l)).length >= 2) {
            output.push('```');
            output.push(...blockLines);
            output.push('```');
          } else {
            output.push(...blockLines);
          }
        } else {
          output.push(lines[i]);
          i++;
        }
      }

      result.push(output.join('\n'));
    }

    return result.join('');
  }

  private buildInlineDiffHtml(code: string, language: string): string {
    const lines = code.split('\n');
    const htmlParts: string[] = [];
    let hunkRemoved: string[] = [];
    let hunkAdded: string[] = [];

    const flushHunk = () => {
      for (const line of hunkRemoved) {
        htmlParts.push(`<div class="ln-del">${line}</div>`);
      }
      for (const line of hunkAdded) {
        htmlParts.push(`<div class="ln-add">${line}</div>`);
      }
      hunkRemoved = [];
      hunkAdded = [];
    };

    for (const rawLine of lines) {
      const delMatch = rawLine.match(/^(\s*)--(.*)/);
      const addMatch = rawLine.match(/^(\s*)\+\+(.*)/);

      if (delMatch) {
        const cleanLine = delMatch[1] + delMatch[2];
        hunkRemoved.push(this.highlightDiffLine(cleanLine, language));
      } else if (addMatch) {
        const cleanLine = addMatch[1] + addMatch[2];
        hunkAdded.push(this.highlightDiffLine(cleanLine, language));
      } else {
        flushHunk();
        htmlParts.push(`<div class="ln-unchanged">${this.highlightDiffLine(rawLine, language)}</div>`);
      }
    }
    flushHunk();
    return htmlParts.join('');
  }

  private highlightDiffLine(content: string, language: string): string {
    try {
      if (language !== 'plaintext' && Prism.languages[language]) {
        return Prism.highlight(content, Prism.languages[language], language);
      }
    } catch (_) { /* fall through */ }
    return content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  copyCodeBlock(index: number) {
    this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
      if (!currentConv || !currentConv.messages[index]) return;
      const msg = currentConv.messages[index];
      // Extract code block from message text
      const codeMatch = msg.text.match(/```([\s\S]*?)```/);
      if (codeMatch && codeMatch[1]) {
        const code = codeMatch[1].trim();
        navigator.clipboard.writeText(code);
      }
    });
  }

  addCopyButtonsToCodeBlocks() {
    if (!this.scrollContainer?.nativeElement) return;

    // Run Prism only on NON-diff pre blocks (diff blocks already have custom HTML)
    try {
      const nonDiffPres = this.scrollContainer.nativeElement.querySelectorAll('pre:not(.diff-view)');
      nonDiffPres.forEach((pre: HTMLElement) => {
        try { Prism.highlightAllUnder(pre); } catch (e) {}
      });
    } catch (e) {}

    const preElements = this.scrollContainer.nativeElement.querySelectorAll('pre');
    preElements.forEach((pre: HTMLElement) => {
      if (pre.querySelector('.copy-btn')) return;
      pre.style.position = 'relative';

      const button = this.renderer.createElement('button');
      this.renderer.addClass(button, 'copy-btn');
      this.renderer.setAttribute(button, 'type', 'button');
      this.renderer.setAttribute(button, 'aria-label', 'Copy code');
      button.innerHTML = '<span class="material-icons">content_copy</span>';

      const onClick = async (ev: Event) => {
        ev.stopPropagation();
        let code: string;
        if (pre.classList.contains('diff-view')) {
          // Copy only the final code: added lines and unchanged lines (skip deleted)
          const lineDivs = pre.querySelectorAll('.ln-add, .ln-unchanged');
          code = Array.from(lineDivs).map((d: Element) => (d as HTMLElement).innerText).join('\n');
        } else {
          code = pre.querySelector('code')?.innerText || pre.innerText || '';
        }
        try {
          await navigator.clipboard.writeText(code);
          button.innerHTML = '<span class="material-icons">check_circle</span>';
          this.renderer.addClass(button, 'copied');
          setTimeout(() => {
            button.innerHTML = '<span class="material-icons">content_copy</span>';
            this.renderer.removeClass(button, 'copied');
          }, 1500);
        } catch (err) {
          this.renderer.removeClass(button, 'copied');
        }
      };

      this.renderer.listen(button, 'click', (ev: Event) => { onClick(ev as Event).catch(() => {}); });
      this.renderer.appendChild(pre, button);
    });
  }

  // scrollToBottom(): void {
  //   try {
  //     this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  //   } catch (err) { }
  // }

  summarizeConversation() {
    this.currentConversation$.pipe(take(1)).subscribe(currentConv => {
      // Removed summarizeConversation logic
    });
  }


  copyToClipboard(msg: Message): void {
    navigator.clipboard.writeText(msg.text).then(() => {
      msg.copied = true;

      setTimeout(() => {
        msg.copied = false;
      }, 2000); // Reset after 2 seconds
    });
  }

  onZoomIn() {
    let newPercentage = this.zoomLevel * 100 + 10;
    this.setZoomPercentage(newPercentage);
  }

  onZoomOut() {
    let newPercentage = this.zoomLevel * 100 - 10;
    this.setZoomPercentage(newPercentage);
  }

  get zoomDisplayValue(): string {
    return Math.round(this.zoomLevel * 100) + '%';
  }

  setZoom(change: number) {
    this.zoomLevel = Math.min(Math.max(this.zoomLevel + change, 0.5), 2);
    this.applyZoomToContainer();
  }

  setZoomPercentage(percentage: number) {
    this.zoomLevel = Math.min(Math.max(percentage / 100, 0.5), 2);
    this.applyZoomToContainer();
    this.showZoomIndicator = true;
    // Hide after 2 seconds automatically (optional)
    setTimeout(() => this.showZoomIndicator = false, 10000);
  }

  toggleZoomIndicator() {
    this.showZoomIndicator = !this.showZoomIndicator;
  }

  resetZoom() {
    console.log("zoom clicked")
    this.zoomLevel = 1; // reset zoom to 100%
    this.applyZoomToContainer();
    this.showZoomIndicator = true;
    setTimeout(() => this.showZoomIndicator = false, 100);
    this.cdr.detectChanges(); // ensure UI updates if needed
  }

  private applyZoomToContainer(): void {
    const el = this.zoomContainer?.nativeElement as HTMLElement | undefined;
    if (!el) return;

    // Prefer CSS `zoom` where supported so scaling works even when styles use `rem`/`px`.
    const supportsZoom = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('zoom', '1');
    if (supportsZoom) {
      el.style.setProperty('zoom', String(this.zoomLevel));
      // Clear any legacy font-size based zooming.
      el.style.removeProperty('font-size');
      el.style.removeProperty('line-height');
      return;
    }

    // Fallback: font-size based zoom (works when typography inherits from the container).
    const baseFontSize = 14;
    const newFontSize = baseFontSize * this.zoomLevel;
    el.style.removeProperty('zoom');
    el.style.fontSize = `${newFontSize}px`;
    el.style.lineHeight = `${newFontSize * 1.4}px`;
  }


  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.menuOpen && this.menuDropdown && !this.menuDropdown.nativeElement.contains(event.target)) {
      this.menuOpen = false;
    }
    const target = event.target as HTMLElement;
    if (!target.closest('.custom-select-wrapper')) {
      this.intervalDropdownOpen = false;
    }
  }


  scrollToBottom(force: boolean = false): void {
    try {
      if (!this.isUserScrolling || force) {
        // mark as programmatic so onScroll ignores it
        this._programmaticScroll = true;
        const el = this.scrollContainer.nativeElement;
        el.scrollTop = el.scrollHeight;
        this.updateNearBottom(el);
        // clear programmatic flag shortly after
        setTimeout(() => { this._programmaticScroll = false; }, 120);
      }
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }

  /**
   * Force scroll to the absolute bottom of the chat, ignoring all flags.
   */
  forceScrollToAbsoluteBottom(): void {
    try {
      if (this.scrollContainer?.nativeElement) {
        this._programmaticScroll = true;
        const el = this.scrollContainer.nativeElement;
        el.scrollTop = el.scrollHeight;
        this.updateNearBottom(el);
        setTimeout(() => { this._programmaticScroll = false; }, 120);
      }
    } catch (err) {
      console.error('Force scroll error:', err);
    }
  }


  // This method is triggered when the user starts scrolling
  onUserScroll(): void {
    const scrollTop = this.scrollContainer.nativeElement.scrollTop;
    const scrollHeight = this.scrollContainer.nativeElement.scrollHeight;
    const clientHeight = this.scrollContainer.nativeElement.clientHeight;

    // User is scrolling manually, we set the flag to true
    this.isUserScrolling = true;

    // Check if the user is near the bottom (e.g., within 50px of the bottom)
    // Use hysteresis logic for isNearBottom
    this.updateNearBottom(this.scrollContainer.nativeElement);
  }

  // This method is triggered when the user stops scrolling
  onUserStopScroll(): void {
    setTimeout(() => {
      if (!this.isStreaming && this.isNearBottom) {
        this.isUserScrolling = false;
        this.scrollToBottom(true);
      }
    }, 1000); // shorter, more responsive
  }

  scrollToBottomWithPadding(padding = 10) {
    const container = this.scrollContainer.nativeElement;
    if (!this.isUserScrolling) { // respects manual user scroll
      this._programmaticScroll = true;
      container.scrollTop = container.scrollHeight - container.clientHeight - padding;
      setTimeout(() => { this._programmaticScroll = false; }, 120);
    }
  }

  /**
   * Called by the template arrow click
   */
  onScrollToBottomClick(): void {
    // user intentionally clicked to go to bottom; force immediate scroll
    this.isUserScrolling = false;
    this.scrollToBottom(true);
  }

  /**
   * Scroll to show last 15% of previous answer and provide more space for new answer
   */
  scrollToShowPreviousAndNewAnswer(): void {
    setTimeout(() => {
      try {
        if (!this.scrollContainer || !this.scrollContainer.nativeElement) return;
        
        const container = this.scrollContainer.nativeElement;
        const messageElements = container.querySelectorAll('.message-wrapper');
        
        if (messageElements.length < 1) {
          return;
        }
        
        if (messageElements.length === 1) {
          // Only one message, position it at top
          this._programmaticScroll = true;
          container.scrollTop = 0;
          this.updateNearBottom(container);
          setTimeout(() => { this._programmaticScroll = false; }, 120);
          return;
        }
        
        // Get the second-to-last message (previous answer)
        const previousMsg = messageElements[messageElements.length - 2] as HTMLElement;
        
        const previousMsgHeight = previousMsg.offsetHeight;
        const previousMsgTop = previousMsg.offsetTop;
        
        // Show last 15% of previous message at top
        const targetScrollTop = previousMsgTop + (previousMsgHeight * 0.85);
        
        this._programmaticScroll = true;
        container.scrollTop = Math.max(0, targetScrollTop);
        this.updateNearBottom(container);
        
        setTimeout(() => { this._programmaticScroll = false; }, 120);
      } catch (err) {
        console.error('Scroll to previous/new answer error:', err);
      }
    }, 150);
  }

  // private startStreamingAutoScroll(): void {
  //   // restart autoscroll so duration counts from latest chunk
  //   this.stopStreamingAutoScroll();

  //   this.streamingAutoScrollInterval = setInterval(() => {
  //     try {
  //       if (!this.scrollContainer || !this.scrollContainer.nativeElement) return;

  //       const el = this.scrollContainer.nativeElement;
  //       const remaining = el.scrollHeight - el.scrollTop - el.clientHeight;
  //       if (remaining <= 0) {
  //         // reached bottom
  //         this.stopStreamingAutoScroll();
  //         this.updateNearBottom(el);
  //         this.isStreaming = false;
  //         return;
  //       }

  //       const step = Math.min(this.autoScrollStep, remaining);
  //       this._programmaticScroll = true;
  //       el.scrollTop = el.scrollTop + step;
  //       // if we are close now, mark near bottom
  //       this.updateNearBottom(el);
  //       // clear flag shortly after
  //       setTimeout(() => { this._programmaticScroll = false; }, 120);
  //     } catch (err) {
  //       // swallow
  //     }
  //   }, this.autoScrollIntervalMs);
  // }

  private stopStreamingAutoScroll(): void {
    if (this.streamingAutoScrollInterval) {
      clearInterval(this.streamingAutoScrollInterval);
      this.streamingAutoScrollInterval = null;
    }
    // mark streaming as ended
    this.isStreaming = false;
  }
  private startAutoScrollInterval() {
    if (this.autoScrollInterval) clearInterval(this.autoScrollInterval);
    // Use the selected interval time (default to 15s if not set)
    const intervalMs = (this.autoScrollIntervalSeconds || 15) * 1000;
    this.isAutoScrolling = true;
    // Hide scroll-to-bottom icon for the entire auto-scroll session
    let autoScrollActive = true;
    this.autoScrollInterval = setInterval(() => {
      if (!this.scrollContainer?.nativeElement) return;
      const el = this.scrollContainer.nativeElement;
      const remaining = el.scrollHeight - el.scrollTop - el.clientHeight;
      // If already at the bottom, just wait for next interval (don't stop auto-scroll)
      if (remaining <= 0 || Math.abs(el.scrollTop - (el.scrollHeight - el.clientHeight)) < 2) {
        // Already at bottom, keep auto-scroll enabled and wait for next interval
        return;
      }
      // Scroll distance is proportional to interval (e.g., 1/5th of container height)
      const proportionalStep = Math.max(80, Math.floor(el.clientHeight / 5));
      const step = proportionalStep;
      this._programmaticScroll = true;
      this.autoScrollAnimating = true;
      // Make initial scroll smooth, subsequent scrolls faster
      let duration;
      if (!this.autoScrollSpeedup) {
        duration = Math.max(800, Math.floor(intervalMs * 0.8)); // smooth, longer animation
      } else {
        duration = Math.max(300, Math.floor(intervalMs * 0.3)); // faster after user interaction
      }
      const start = el.scrollTop;
      const end = Math.min(el.scrollTop + step, el.scrollHeight - el.clientHeight);
      const startTime = performance.now();
      const animate = (now: number) => {
        // Check if animation was cancelled
        if (!this.autoScrollAnimating) {
          this._programmaticScroll = false;
          return;
        }
        const elapsed = now - startTime;
        // Ease-in-out timing function
        const t = Math.min(elapsed / duration, 1);
        const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        el.scrollTop = start + (end - start) * ease;
        if (t < 1) {
          this.animationFrameId = requestAnimationFrame(animate);
        } else {
          this._programmaticScroll = false;
          this.autoScrollAnimating = false;
          this.animationFrameId = null;
        }
      };
      this.animationFrameId = requestAnimationFrame((now) => animate(now));
    }, intervalMs);
  }


}
